import { render, staticRenderFns } from "./ssoMobile.vue?vue&type=template&id=f35d16a2&scoped=true&"
import script from "./ssoMobile.vue?vue&type=script&lang=js&"
export * from "./ssoMobile.vue?vue&type=script&lang=js&"
import style0 from "./ssoMobile.vue?vue&type=style&index=0&id=f35d16a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35d16a2",
  null
  
)

export default component.exports